import React, { useState } from "react";
import { db } from "../config/firebaseConfig"; // Firebase config dosyanız
import { collection, addDoc } from "firebase/firestore";
import axios from "axios"; // axios'u import et

const PortfolyoEkle = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("web design"); // Varsayılan kategori
  const [imageFile, setImageFile] = useState(null); // Yüklenmek üzere seçilen dosya
  const [link, setLink] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false); // Yükleme durumu

  // Cloudinary ile görsel yükleme ve Firestore'a kaydetme
  const uploadToCloudinaryAndSaveToFirestore = async () => {
    if (!imageFile) {
      setError("Lütfen bir resim dosyası seçin.");
      return;
    }

    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("upload_preset", "blog_upload"); // Cloudinary upload preset
    formData.append("api_key", "771442818997162"); // Cloudinary API Key

    setLoading(true);
    try {
      // Cloudinary'e yükleme
      const response = await axios.post(
        "https://api.cloudinary.com/v1_1/untitled/image/upload", // Cloud Name: "untitled"
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 15000, // 15 saniye timeout
        }
      );

      const imageUrl = response.data.secure_url;
      console.log("Cloudinary URL:", imageUrl);

      // Firestore'a kaydetme
      await addDoc(collection(db, "projects"), {
        title,
        category,
        image: imageUrl, // Cloudinary'den gelen URL
        link,
        description,
        createdAt: new Date().toISOString(),
      });

      setSuccess("Proje başarıyla eklendi!");
      // Formu sıfırla
      setTitle("");
      setCategory("web design");
      setImageFile(null);
      setLink("");
      setDescription("");
      setError("");
    } catch (error) {
      console.error("Cloudinary Hatası:", error.message, error.response?.data);
      if (error.code === "ECONNABORTED") {
        setError("İstek zaman aşımına uğradı. Lütfen tekrar deneyin.");
      } else if (error.response) {
        setError(`Yükleme Hatası: ${error.response.data?.message || error.message}`);
      } else {
        setError("Ağ hatası: Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin.");
      }
      setSuccess("");
    } finally {
      setLoading(false);
    }
  };

  // Form gönderimi
  const handleSubmit = (e) => {
    e.preventDefault();

    // Zorunlu alanların kontrolü
    if (!title.trim() || !link.trim() || !description.trim() || !imageFile) {
      setError("Lütfen tüm alanları doldurun ve bir resim seçin.");
      return;
    }

    uploadToCloudinaryAndSaveToFirestore();
  };

  // Dosya seçimi
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };

  return (
    <div className="container-fluid">
      <h1 className="h3 mb-4 text-gray-800">Portfolyo Ekle</h1>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">Yeni Proje Ekle</h6>
        </div>
        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="title">Proje Başlığı</label>
              <input
                type="text"
                className="form-control"
                id="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Proje başlığını girin"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="category">Kategori</label>
              <select
                className="form-control"
                id="category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
              >
                <option value="web design">Web Tasarım</option>
                <option value="e-commerce">E-Ticaret</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="imageFile">Proje Resmi</label>
              <input
                type="file"
                className="form-control"
                id="imageFile"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="link">Proje Linki</label>
              <input
                type="url"
                className="form-control"
                id="link"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                placeholder="Proje linkini girin (örn: https://example.com)"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Açıklama</label>
              <textarea
                className="form-control"
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Proje açıklamasını girin"
                rows="3"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Yükleniyor..." : "Proje Ekle"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PortfolyoEkle;